// extracted by mini-css-extract-plugin
export default {"icon":"BSALogo__icon___WWSyC"};